import React from 'react';

import Navbar from './components/navbar';
import styled from 'styled-components';
import Home from './sections/home';
import About from './sections/about';
import Services from './sections/services';
import Portfolio from './sections/portfolio';
import Contact from './sections/contact';
import Sidebar from './components/sidebar';
import Footer from './sections/footer';

const Main = styled.main`
  @media (min-width: 1024px) {
    margin-left: 15%;
  }
`;

const App = () => {
  return (
    <>
      <Sidebar/>
      <Navbar />
      <Main>
        <Home />
        <About />
        <Services />
        <Portfolio />
        <Contact />
      </Main>
      <Footer/>
    </>
  );
};

export default App;
